<template>
  <div class="container-research">
    <v-row class="page-preferences" column fill-height formlittle>
      <v-col class="py-0">
        <v-card class="mb-4 flex-grow-1 card card-personalpreference">
          <v-card-title>
            <h1>
              Résultats de votre
              <span class="bis">recherche</span> :
            </h1>
          </v-card-title>
          <v-card-text v-if="researchResponse">
            <h2>{{researchResponse.total_co}} contact(s) trouvés</h2>
            <div v-for="row_co in researchResponse.rows_co" :key="row_co.co_id">
              <a
                @click="goToResearch('contacts', row_co.co_id)"
              >{{$options.filters.formatContactName(row_co)}}</a>
              <br />
            </div>

            <h2>{{researchResponse.total_of}} Bien(s) trouvés</h2>
            <div v-for="row_of in researchResponse.rows_of" :key="row_of.of_id">
              <a
                @click="goToResearch('offers' , row_of.of_id)"
              >{{$options.filters.formatOfferName(row_of)}}</a>
            </div>

            <h2>{{researchResponse.total_ac}} action(s) trouvées</h2>
            <div v-for="row_ac in researchResponse.rows_ac" :key="row_ac.ac_id">
              <a
                @click="goToResearch('home' , row_ac.ac_id)"
              >{{$options.filters.formatActionName(row_ac)}}</a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "researchview",
  props: {
    researchVal: String
  },
  components: {},
  data() {
    return {
      researchResponse: {}
    };
  },
  mounted() {
    this.research();
  },
  watch: {
    researchVal: function(val) {
      this.research(val);
    }
  },
  methods: {
    async research() {
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/searches/search/" + this.researchVal
      );
      this.researchResponse = response.data;
    },
    goToResearch(route, id) {
      this.$emit("deleteResearch");
      if (route === "home") {
        //this.$router.push({ name: "home", query: { action: id } });
      } else {
        this.$router.push("/" + route + "/" + id + "/details");
      }
    }
  }
};
</script>
<style scoped>
.container-research {
  width: 100%;
  height: 100%;
}
</style>
